var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-checkbox',{attrs:{"id":_vm.itemID,"inputValue":_vm.value,"value":_vm.value,"disabled":_vm.disabled,"success":""},on:{"change":_vm.courseDayResultsEmail}})}
var staticRenderFns = []

export { render, staticRenderFns }